import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Override18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_645)'>
      <path
        d='M7.46973 3.53034L12.1894 8.25001L1 8.25001L1 9.75001L12.1894 9.75001L7.46973 14.4697L8.53039 15.5303L15.0607 9.00001L8.53039 2.46968L7.46973 3.53034Z'
        fill='currentColor'
      />
      <path
        d='M16.25 3.00001V15H17.75V3.00001L16.25 3.00001Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_645'>
        <rect
          width='18'
          height='18'
          fill='white'
          transform='translate(0 18) rotate(-90)'
        />
      </clipPath>
    </defs>
  </Svg>
);

Override18.displayName = 'Override18';
export default Override18;
